<div class="emma-card__header">
    <div fxLayout="row" fxLayoutAlign="space-between center">
        <div>
            @if (showDeviceLink && !contextService.isKioskModeEnabled) {
                <a [routerLink]="device?.id ? '/device/' + device.id : null">{{ device?.deviceName }}</a>
            }
            @if (!showDeviceLink || contextService.isKioskModeEnabled) {
                <span>{{ device?.deviceName }}</span>
            }
            - {{ "FIELD." + dataType | translate }}
        </div>
        @if (editGraphViews) {
            <app-device-view-list [device]="device" [dataType]="dataType"></app-device-view-list>
        }
    </div>
</div>

@if (device?.lastData) {
    <div class="emma-card__content">
        <small>{{
            device?.lastData?.[dataType === "spectrum_13_octave_1m" ? "spectrum13Octave1Minute" : "spectrum13Octave"]?.timestamp
                | date: "medium"
        }}</small>
    </div>
}

@if (!device?.lastData) {
    <div class="emma-card__content emma-card__content--center">
        <small>{{ "COMPONENT.NoData" | translate }}</small>
        <div>
            <b>
                {{ "COMPONENT.DeviceDisconnected" | translate }}
            </b>
        </div>
    </div>
}

@if (device?.lastData) {
    <div class="emma-card__footer-full-width">
        <highcharts-chart
            [Highcharts]="Highcharts"
            [constructorType]="chart.constructor"
            [options]="chart.options"
            [(update)]="chart.update"
            class="device-band-spectra__chart"
            [callbackFunction]="chartCallback"
        ></highcharts-chart>
    </div>
}

@if (!device?.connected && device?.lastData) {
    <div class="emma-card__offline">
        {{ "COMPONENT.DeviceOffline" | translate }}
    </div>
}
